import React  from 'react';
import PropTypes from 'prop-types';
import ConfigComponent from '../ConfigComponent';

export const SystemUnavailable = ({imgSrc, description}) => {
  return (
    <div className="system-outage">
      <section>
        <img src={imgSrc} alt="" className="system-outage-logo"/>
      </section>
      <section>
        <p><ConfigComponent config={description} /></p>
      </section>
    </div>
  )
};

SystemUnavailable.propTypes = {
  imgSrc: PropTypes.string,
  description: PropTypes.string,
};

export default SystemUnavailable;
